
seedWebApp.controller('SkuFavoritesAddModalController', ['$scope', '$uibModalInstance', 'TranslationService', 'favorite',
    function SkuFavoritesAddModalController($scope, $uibModalInstance, TranslationService, favorite) {
        $scope.translation = TranslationService.getActiveTranslation();
        //console.log('OrderAcceptModalCtrl.order');

        console.log('SkuFavoritesAddModalController');

        $scope.favorite = favorite;


        $scope.save = function () {
            /*
            if ($scope.favorite) {
                $scope.favorite.Skus.push({ SkuID: product.SkuID, SkuName: product.SkuName });
            }
            */
            $uibModalInstance.close($scope.favorite, 'save');
        };

        $scope.delete = function () {
            /*
            if ($scope.favorite) {
                $scope.favorite.Skus.push({ SkuID: product.SkuID, SkuName: product.SkuName });
            }
            */
            $scope.favorite.ActionID = 'delete';
            $uibModalInstance.close($scope.favorite, 'delete');
        };
        

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };


    }]
);